<p-dialog
  *ngIf="category"
  [appendTo]="'body'"
  [(visible)]="detailsControl.isOpen"
  [position]="'right'"
  [style]="{ width: '55vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  (visibleChange)="hideDialog()"
>
  <div class="flex justify-content-between align-items-center mt-2">
    <div class="flex gap-2 align-items-center">
      <button class="secondary-button p-0 mr-2" (click)="hideDialog()" data-clarity-unmask="true">
        X
      </button>
    </div>
  </div>

  <ng-template pTemplate="content">
    <div
      class="flex flex-column md:flex-row justify-content-between align-content-center mt-3 md:mt-5 mb-4 gap-1 md:gap-3"
    >
      <div class="font-semibold text-xl">{{ category.name }}</div>
      <div
        *ngIf="category.created"
        class="flex justify-content-start md:justify-content-center align-items-center text-sm text-400"
      >
        Edytowano: {{ category.created | date : "dd.MM.yyyy HH:mm" }}
      </div>
    </div>

    <form [formGroup]="categoryForm">
      <div
        class="form-decorator top-decorator flex w-full justify-content-left align-items-center mb-6"
      >
        <div class="title">Pokaż w aplikacji</div>
        <div class="w-full">
          <div
            *ngIf="!detailsControl.isEditing"
            class="flex align-items-center gap-2"
          >
            <p-inputSwitch
              formControlName="isActive"
              [disabled]="true"
              readonly
            />
          </div>

          <div
            *ngIf="detailsControl.isEditing"
            class="w-full flex justify-content-left align-items-center gap-2"
          >
            <p-inputSwitch formControlName="isActive" />
          </div>
        </div>
      </div>
      <div
        class="form-decorator top-decorator flex w-full justify-content-left align-items-center mb-6"
      >
        <div class="title">Przypisane kategorie egzaminów</div>
        <div class="w-full">
          <div
            *ngIf="!detailsControl.isEditing"
            class="flex align-items-center gap-2"
          >
            <div
              class="w-full"
              *ngIf="
                category.examCategories && category.examCategories.length > 0;
                else noExams
              "
            >
              <input
                type="text"
                class="default-input input-off w-full"
                [value]="getExamNamesDisplay()"
                readonly
              />
            </div>
            <ng-template #noExams>
              <input
                type="text"
                class="default-input input-off w-full flex-1"
                value="Brak przypisanych kategorii"
                readonly
              />
            </ng-template>
          </div>

          <div
            *ngIf="detailsControl.isEditing"
            class="w-full flex justify-content-left align-items-center gap-2"
          >
            <p-multiSelect
              id="examsGuid"
              formControlName="examsGuid"
              [options]="availableExams"
              optionValue="guid"
              optionLabel="examName"
              placeholder="Wybierz kategorie"
              styleClass="custom-multiselect w-full"
              class="w-full"
              [showToggleAll]="false"
              [filter]="false"
            >
            </p-multiSelect>
          </div>
        </div>
      </div>

      <div
        class="form-decorator top-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Nazwa działu wykładu (PL)</div>
        <div class="w-full">
          <div
            *ngIf="!detailsControl.isEditing"
            class="flex align-items-center"
          >
            <input
              type="text"
              class="default-input input-off w-full flex-1"
              [value]="category.name || 'Brak nazwy głównej'"
              readonly
            />
          </div>

          <div *ngIf="detailsControl.isEditing">
            <div class="flex align-items-center gap-2">
              <input
                type="text"
                class="default-input w-full flex-1"
                formControlName="name"
                placeholder="Wprowadź nazwę główną działu"
                [class.input-error]="
                  categoryForm.get('name')?.invalid &&
                  categoryForm.get('name')?.touched
                "
              />
            </div>

            <small
              class="p-error block mt-1"
              *ngIf="
                categoryForm.get('name')?.invalid &&
                categoryForm.get('name')?.touched
              "
            >
              Nazwa główna jest wymagana
            </small>
          </div>
        </div>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Kolejność wyświetlania</div>
        <div class="w-full">
          <div
            *ngIf="!detailsControl.isEditing"
            class="flex align-items-center gap-2"
          >
            <input
              type="text"
              class="default-input input-off w-full flex-1"
              [value]="category.order || 0"
              readonly
            />
          </div>

          <div
            *ngIf="detailsControl.isEditing"
            class="w-full flex justify-content-left align-items-center gap-2"
          >
            <input
              type="number"
              class="default-input w-full"
              formControlName="order"
              placeholder="0"
              min="0"
            />
          </div>
        </div>
      </div>
    </form>

    <div
      class="mt-6 mb-3 text-gray-500 gap-2 flex justify-content-start align-items-center"
    >
      <i class="pi pi-flag"></i> Wersje językowe
    </div>

    <div class="translations-container">
      <div
        class="translation-section"
        *ngFor="let language of availableLanguages; let i = index"
      >
        <div *ngIf="language.code !== 'pl'">
          <div
            class="form-decorator flex w-full justify-content-left align-items-center"
            [ngClass]="language.code === 'en' ? 'top-decorator' : ''"
          >
            <div class="title">
              Nazwa działu wykładu ({{ language.code }})
            </div>
            <div class="w-full">
              <div
                *ngIf="!editingTranslation[language.code]"
                class="flex align-items-center"
              >
                <div
                  *ngIf="hasTranslation(language.code); else noTranslation"
                  class="flex-1"
                >
                  <input
                    type="text"
                    class="default-input input-off w-full"
                    [value]="getTranslationName(language.code)"
                    readonly
                  />
                </div>
                <ng-template #noTranslation>
                  <input
                    type="text"
                    class="default-input input-off w-full flex-1"
                    value="Brak tłumaczenia"
                    readonly
                  />
                </ng-template>

                <div class="flex gap-1 ml-2">
                  <button
                    pTooltip="Edytuj tłumaczenie"
                    type="button"
                    class="transparent-button"
                    [disabled]="detailsControl.isEditing || !canEditTranslation(language.code)"
                    (click)="enableTranslationEditing(language.code)"
                    data-clarity-unmask="true"
                  >
                    <i class="pi pi-pencil"></i>
                  </button>

                  <button
                    type="button"
                    pTooltip="Usuń tłumaczenie"
                    class="transparent-button"
                    *ngIf="hasTranslation(language.code)"
                    [disabled]="detailsControl.isEditing || !canEditTranslation(language.code)"
                    (click)="deleteTranslation(language.code)"
                    data-clarity-unmask="true"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </div>

              <div *ngIf="editingTranslation[language.code]">
                <form
                  [formGroup]="translationForms[language.code]"
                  (ngSubmit)="saveTranslation(language.code)"
                >
                  <div class="flex align-items-center gap-2">
                    <input
                      type="text"
                      class="default-input w-full flex-1"
                      formControlName="name"
                      placeholder="Wprowadź nazwę działu"
                      [class.input-error]="
                        translationForms[language.code].get('name')?.invalid &&
                        translationForms[language.code].get('name')?.touched
                      "
                    />

                    <button
                      type="submit"
                      pTooltip="Zapisz tłumaczenie"
                      class="transparent-button"
                      [disabled]="
                        translationForms[language.code].invalid ||
                        savingTranslation[language.code]
                      "
                      data-clarity-unmask="true"
                    >
                      <i
                        class="pi pi-check"
                        *ngIf="!savingTranslation[language.code]"
                      ></i>
                      <i
                        class="pi pi-spin pi-spinner"
                        *ngIf="savingTranslation[language.code]"
                      ></i>
                    </button>

                    <button
                      type="button"
                      pTooltip="Anuluj"
                      class="transparent-button"
                      [disabled]="savingTranslation[language.code]"
                      (click)="cancelTranslationEditing(language.code)"
                      data-clarity-unmask="true"
                    >
                      <i class="pi pi-times"></i>
                    </button>
                  </div>

                  <small
                    class="p-error block mt-1"
                    *ngIf="
                      translationForms[language.code].get('name')?.invalid &&
                      translationForms[language.code].get('name')?.touched
                    "
                  >
                    Nazwa jest wymagana
                  </small>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex flex-wrap gap-2 w-full align-items-center justify-content-between mb-2">
      <div *ngIf="detailsControl.isEditing" class="flex gap-2">
        <p-button
          [disabled]="!categoryForm.valid || isSaving"
          (onClick)="saveCategory()"
          label="Zapisz zmiany"
          [icon]="isSaving ? 'pi pi-spin' : 'pi pi-save'"
          data-clarity-unmask="true"
        ></p-button>
        <p-button
          label="Anuluj"
          [link]="true"
          (onClick)="editToggle()"
          [disabled]="isSaving"
          data-clarity-unmask="true"
        >
        </p-button>
      </div>

      <div *ngIf="!detailsControl.isEditing">
        <p-button 
          label="Edytuj" 
          icon="pi pi-pencil" 
          (onClick)="editToggle()"
          [disabled]="isAnyTranslationBeingEdited()"
          [title]="isAnyTranslationBeingEdited() ? 'Zakończ edycję tłumaczenia przed rozpoczęciem edycji głównego formularza' : ''" data-clarity-unmask="true">
        </p-button>
      </div>

      <p-button
        icon="pi pi-trash"
        label="Usuń dział"
        [outlined]="true"
        (onClick)="deleteCategory()"
        data-clarity-unmask="true"
      >
      </p-button>
    </div>
  </ng-template>
</p-dialog>
